type SplitTarget = Element | NodeListOf<Element> | Element[] | null | undefined;

export class SplitCharsService {
    /** legacy `window.splitChars` 와 동일 시그니처. 페이지/다른 컨트롤러에서도 호출 가능. */
    static split(target: SplitTarget): void {
        if (!target) return;

        const els =
            target instanceof Element
                ? [target]
                : Array.from(target as ArrayLike<Element>);

        els.forEach((el) => {
            if (!el) return;

            let source = el.getAttribute("data-origin-text");
            if (!source) {
                source = (el.getAttribute("aria-label") || el.textContent || "").trim();
                el.setAttribute("data-origin-text", source);
            }
            if (!source) return;

            el.setAttribute("aria-label", source);
            el.textContent = "";

            const frag = document.createDocumentFragment();
            const words = source.split(" ");

            words.forEach((word, i) => {
                if (!word) return;

                const wordWrap = document.createElement("span");
                wordWrap.className = "word";
                wordWrap.style.display = "inline-block";
                wordWrap.style.whiteSpace = "nowrap";

                for (let j = 0; j < word.length; j++) {
                    const s = document.createElement("span");
                    s.className = "char";
                    s.textContent = word[j];
                    wordWrap.appendChild(s);
                }

                frag.appendChild(wordWrap);

                if (i < words.length - 1) {
                    const space = document.createElement("span");
                    space.className = "space";
                    space.textContent = " ";
                    frag.appendChild(space);
                }
            });

            el.appendChild(frag);
            (el as HTMLElement).dataset.splitDone = "1";
        });
    }

    /** legacy 호환: window.splitChars 글로벌로 노출. */
    static expose(): void {
        (window as unknown as { splitChars: typeof SplitCharsService.split }).splitChars =
            SplitCharsService.split;
    }
}
